import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import WorksAt from "contact/detail/worksAt/app";
import UserTasksPanel from "userTask/list/app";
import NotesPanel from "note/list/app";
import EmailsPanel from "email/list/App";
import DocumentFromTemplatePanel from "DocumentFromTemplate/app";
import OnlineStoragePanel from "show/files/app";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import AreYouSureModal from "components/modals/AreYouSureModal";
import ContactMergeModal from "./merge/app";
import { type UploadFilesConfig, uploadFilesToCoreApi } from "utilities/fileUploadUtils";
import { isPanelVisible } from "utilities/panelUtils";
import { ContactDetailSection } from "contact/detail/ContactMainSection";
import { useLoaderData } from "react-router";
import ContactActivityPanel from "./activity/App";

const ContactDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ContactDetailFrontModel>();
  const { contact } = viewModel;
  const [displayDeleteModal, setDisplayDeleteModal] = React.useState(false);
  const [displayMergeModal, setDisplayMergeModal] = React.useState(false);
  const [displayRestoreModal, setDisplayRestoreModal] = React.useState(false);

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ContactDetailSection contact={contact} />

      {isPanelVisible(viewModel.linkedCompanyPanelConfig) && <WorksAt
        config={viewModel.linkedCompanyPanelConfig}
      />}

      {isPanelVisible(viewModel.linkedUserTaskPanelConfig) && <UserTasksPanel
        config={viewModel.linkedUserTaskPanelConfig}
        mainArea="contact"
      />}

      {isPanelVisible(viewModel.linkedNotePanelConfig) && <NotesPanel
        config={viewModel.linkedNotePanelConfig}
        mainArea="contact"
      />}

      {isPanelVisible(viewModel.linkedEmailPanelConfig) && <EmailsPanel
        emailTemplateType="contactEmailTemplate"
        config={viewModel.linkedEmailPanelConfig}
        mainArea="contact"
      />}

      {isPanelVisible(viewModel.generateDocumentPanelConfig) && <DocumentFromTemplatePanel
        itemId={contact.contactId}
        api={window.CoreApi.Contact.ExportOptionsForDetail}
        panelTitle={viewModel.generateDocumentPanelConfig.headerLabel}
      />}

      {isPanelVisible(viewModel.linkedFilePanelConfig) && <OnlineStoragePanel
        config={viewModel.linkedFilePanelConfig}
        fetchFilesApi={(page, perPage) => window.CoreApi.Contact.PaginatedFiles({ parentId: viewModel.linkedFilePanelConfig.itemId, page, perPage })}
        uploadFiles={(files: File[], uploadConfig: UploadFilesConfig) => {
          return uploadFilesToCoreApi(
            window.CoreApi.File.UploadClientFiles,
            window.CoreApi.File.UploadClientFiles.absoluteUrl(),
            {
              files,
              mainArea: "contact",
              parentId: viewModel.linkedFilePanelConfig.itemId
            },
            uploadConfig
          );
        }}
      />}

      {displayDeleteModal && <AreYouSureModal
        title={RESX.GeneralLabels.Delete}
        textContent={RESX.GeneralWarnings.DeleteSure}
        onClose={() => { setDisplayDeleteModal(false); }}
        onYes={async () => window.CoreApi.Contact.Delete(contact.contactId).then(() => window.location.href = viewModel.listUrl)}
        yesButtonLabel={RESX.GeneralLabels.Delete}
        yesButtonColor="red"
      />}

      {displayRestoreModal && <AreYouSureModal
        title={RESX.Buttons.Restore}
        yesButtonLabel={RESX.Buttons.Restore}
        yesButtonColor="red"
        onClose={() => { setDisplayRestoreModal(false); }}
        onYes={async () => window.CoreApi.Contact.Restore(contact.contactId).then(() => { window.location.reload(); })}
      />}

      <ContactMergeModal
        isOpen={displayMergeModal}
        contactId={contact.contactId}
        contactFullName={contact.name.fullName}
        onClose={() => { setDisplayMergeModal(false); }}
      />

    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        shortcutOrder={["worksAt", "task", "note", "email", "file"]}
        links={[
          { text: RESX.Buttons.ListView, visible: true, href: viewModel.listUrl },
          { text: RESX.OptionsPanel.Merge, visible: contact.permissions.canMerge, onClick: () => { setDisplayMergeModal(true); } },
          { text: RESX.Buttons.btnDelete, visible: contact.permissions.canDelete, onClick: () => { setDisplayDeleteModal(true); } },
          { text: RESX.Buttons.Restore, visible: contact.permissions.canRestore, onClick: () => { setDisplayRestoreModal(true); } }
        ]}
      />

      {isPanelVisible(viewModel.activityPanelConfig) && <ContactActivityPanel
        contactId={contact.contactId}
        config={viewModel.activityPanelConfig}
      />}
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>;
};

export default ContactDetailApp;